import { DigitalChannelsFW } from '../../../../../../../customized/fresh-watch/components/DigitalChannels/DigitalChannelsFW';
import { ToggleComponent } from '../../../../../../../featureToggle';
import { DigitalChannels } from './DigitalChannels';
export * from './DigitalChannels';

export default ToggleComponent(DigitalChannels, {
  styledComponentsVariants: {
    'fresh-watch': DigitalChannelsFW,
  },
});
